"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAreaChartUiConfig = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var uiConfig_1 = require("../../constants/uiConfig");
var bucket_1 = require("../../constants/bucket");
var bucketRules_1 = require("../bucketRules");
var bucketHelper_1 = require("../bucketHelper");
var baseChartUiConfigHelper_1 = require("./baseChartUiConfigHelper");
var translations_1 = require("../translations");
var locales_1 = require("../../../locales");
// If you need to edit these icons
// reflect changes also in gdc-analytical-designer
// https://github.com/gooddata/gdc-analytical-designer/blob/develop/app/components/buckets/BucketIcon.tsx
var areaMeasuresIcon = "local:area/bucket-title-measures.svg";
var areaViewIcon = "local:area/bucket-title-view.svg";
var areaStackIcon = "local:area/bucket-title-stack.svg";
function getWarningMessageForMeasuresBucket(intl, categoriesCount, stackItems, viewItems) {
    return categoriesCount > 1
        ? baseChartUiConfigHelper_1.getBucketItemsWarningMessage(locales_1.messages.metricView.id, intl, viewItems)
        : baseChartUiConfigHelper_1.getBucketItemsWarningMessage(locales_1.messages.metricStack.id, intl, stackItems);
}
function getWarningMessageForViewByBucket(intl, measuresCount, stackItems) {
    return measuresCount > 1
        ? translations_1.getTranslation(locales_1.messages.categoryView.id, intl)
        : baseChartUiConfigHelper_1.getBucketItemsWarningMessage(locales_1.messages.viewStack.id, intl, stackItems);
}
function getWarningMessageForStackByBucket(intl, categoriesCount) {
    return categoriesCount > 1
        ? translations_1.getTranslation(locales_1.messages.stackView.id, intl)
        : translations_1.getTranslation(locales_1.messages.measureStack.id, intl);
}
function setAreaChartBucketWarningMessages(referencePoint, messageConfig) {
    var _a;
    var buckets = (_a = referencePoint === null || referencePoint === void 0 ? void 0 : referencePoint.buckets) !== null && _a !== void 0 ? _a : [];
    var updatedUiConfig = referencePoint === null || referencePoint === void 0 ? void 0 : referencePoint.uiConfig;
    return buckets.reduce(function (uiConfig, bucket) {
        var _a, _b, _c;
        var localIdentifier = (_a = bucket === null || bucket === void 0 ? void 0 : bucket.localIdentifier) !== null && _a !== void 0 ? _a : "";
        var bucketUiConfig = (_b = uiConfig === null || uiConfig === void 0 ? void 0 : uiConfig.buckets) === null || _b === void 0 ? void 0 : _b[localIdentifier];
        var isEnabled = (_c = bucketUiConfig === null || bucketUiConfig === void 0 ? void 0 : bucketUiConfig.enabled) !== null && _c !== void 0 ? _c : false;
        var canAddItem = bucketUiConfig === null || bucketUiConfig === void 0 ? void 0 : bucketUiConfig.canAddItems;
        // skip disabled buckets
        if (canAddItem || !isEnabled) {
            return uiConfig;
        }
        var warningMessage = messageConfig[localIdentifier];
        return set_1.default(uiConfig, [bucket_1.BUCKETS, localIdentifier, "warningMessage"], warningMessage);
    }, updatedUiConfig);
}
function setAreaChartUiConfig(referencePoint, intl, visualizationType) {
    var _a;
    var _b;
    var referencePointConfigured = cloneDeep_1.default(referencePoint);
    var buckets = (_b = referencePointConfigured === null || referencePointConfigured === void 0 ? void 0 : referencePointConfigured.buckets) !== null && _b !== void 0 ? _b : [];
    var categoriesCount = bucketHelper_1.getItemsCount(buckets, sdk_ui_1.BucketNames.VIEW);
    var stackItems = bucketHelper_1.getStackItems(buckets, [bucket_1.ATTRIBUTE, bucket_1.DATE]);
    var viewItems = bucketHelper_1.getViewItems(buckets, [bucket_1.ATTRIBUTE, bucket_1.DATE]);
    var measuresCount = bucketRules_1.getMasterMeasuresCount(buckets, sdk_ui_1.BucketNames.MEASURES);
    var isStackEmpty = bucketRules_1.hasNoStacksWithDate(buckets);
    var canAddMeasuresItems = !measuresCount || (categoriesCount <= 1 && isStackEmpty);
    var canAddViewItems = !categoriesCount || (measuresCount <= 1 && isStackEmpty);
    var canAddStackItems = categoriesCount <= 1 && measuresCount <= 1;
    var messageConfig = (_a = {},
        _a[sdk_ui_1.BucketNames.MEASURES] = getWarningMessageForMeasuresBucket(intl, categoriesCount, stackItems, viewItems),
        _a[sdk_ui_1.BucketNames.VIEW] = getWarningMessageForViewByBucket(intl, measuresCount, stackItems),
        _a[sdk_ui_1.BucketNames.STACK] = getWarningMessageForStackByBucket(intl, categoriesCount),
        _a);
    set_1.default(referencePointConfigured, uiConfig_1.UICONFIG, bucketHelper_1.setBucketTitles(referencePoint, visualizationType, intl));
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.MEASURES, "canAddItems"], canAddMeasuresItems);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.VIEW, "canAddItems"], canAddViewItems);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.STACK, "canAddItems"], canAddStackItems);
    setAreaChartBucketWarningMessages(referencePointConfigured, messageConfig);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.MEASURES, "icon"], areaMeasuresIcon);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.VIEW, "icon"], areaViewIcon);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.STACK, "icon"], areaStackIcon);
    return referencePointConfigured;
}
exports.setAreaChartUiConfig = setAreaChartUiConfig;
//# sourceMappingURL=areaChartUiConfigHelper.js.map